/**
 * New Frequency name sticky + duplicate helpers for MaintenanceTaskModal.
 * Shared with unit tests so recurrence patches cannot overwrite a typed label (REBUILD-440).
 */

import {
  buildCalendarAutoName,
  buildTimedAutoName,
} from '@/shared/lib/frequency/format-interval-option-label'

const FREQUENCY_TYPE_TIMED = 'TIMED'

/**
 * Auto placeholder for a New Frequency draft. Must match buildAutoName for the active
 * frequency type — otherwise sticky equality fails (Timed kept a Calendar "every week" seed).
 */
export const seedNewIntervalAutoName = (params: {
  frequencyTypeCode: string
  repeatsEveryValue: string
  repeatsEveryUnit: string
  frequencyRrule: string
}): string => {
  if (params.frequencyTypeCode === FREQUENCY_TYPE_TIMED) {
    return buildTimedAutoName({
      repeatsEveryValue: params.repeatsEveryValue,
      repeatsEveryUnit: params.repeatsEveryUnit,
    })
  }

  return buildCalendarAutoName({ frequencyRrule: params.frequencyRrule })
}

export const resolveStickyIntervalName = (params: {
  currentName: string
  previousAutoName: string
  nextAutoName: string
  recurrenceChanged: boolean
}): string => {
  if (!params.recurrenceChanged) return params.currentName
  if (params.currentName === params.previousAutoName) return params.nextAutoName
  return params.currentName
}

/** Case-insensitive trim match against existing frequency option labels (REBUILD-347). */
export const isDuplicateIntervalName = (
  name: string,
  existingDescriptions: Array<string | null | undefined>,
): boolean => {
  const normalizedName = name.trim().toLowerCase()
  if (normalizedName.length === 0) return false

  return existingDescriptions.some(
    (description) => description?.trim().toLowerCase() === normalizedName,
  )
}
